import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Form,
  Input,
  message,
  Modal,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import "./programList.scss";
import {
  programClone,
  programDelete,
  programList,
  reportDownload,
} from "../../../apis/admin";
import { replaceUrlByParams } from "../../../utils/api";

import { PAGE, TIME_FORMAT } from "../../../utils/constants";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ShareAltOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { AppContext } from "../../../App";
import Text from "antd/lib/typography/Text";

function ProgramListPage() {
  let history = useHistory();
  const fileDownload = require("js-file-download");
  const { Title } = Typography;
  const { confirm } = Modal;
  const { Search } = Input;
  const [form] = Form.useForm();
  const [programData, setProgramData] = useState([]);
  const [search, setSearch] = useState("");
  const { setLoading } = useContext(AppContext);

  /*eslint-disable*/
  const columns = [
    {
      title: "課程名稱",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        console.log(record);
        return (
          <div style={{ lineHeight: 1.5 }}>
            <Text>{text}</Text> <br />{" "}
            <Text className="referenceId">{record.referenceId || ""}</Text>
          </div>
        );
      },
    },
    {
      title: "狀態",
      dataIndex: "activated",
      key: "activated",
      render: (status) => {
        return (
          <Tag color={status ? "green" : "red"} key={status}>
            {status ? "進行中" : "已完結"}
          </Tag>
        );
      },
    },
    {
      title: "連結",
      dataIndex: "url",
      key: "url",
      render: (link) => {
        return (
          <>
            <Link
              onClick={(e) => e.stopPropagation()}
              target="_blank"
              to={link}
            >
              課程主頁
            </Link>
            <a
              onClick={(e) => {
                e.stopPropagation();
                message.success("複製成功");
              }}
            >
              <CopyToClipboard
                text={`${window.location.origin}/enrolment/#${link}`}
              >
                <Tooltip title="複製連結到剪貼簿">
                  <ShareAltOutlined />
                </Tooltip>
              </CopyToClipboard>
            </a>
          </>
        );
      },
    },
    {
      title: "更多",
      dataIndex: "more",
      key: "more",
      render: (program) => {
        return (
          <>
            <Tooltip title="編輯">
              <Link
                onClick={(e) => e.stopPropagation()}
                to={`${replaceUrlByParams(PAGE.ADMIN_PROGRAM_DETAIL_EDIT, {
                  ":pid": program.pid,
                })}`}
              >
                <EditOutlined />
              </Link>
            </Tooltip>
            <Tooltip title="複製課程">
              <a onClick={(e) => onClone(e, program)}>
                <CopyOutlined />
              </a>
            </Tooltip>
            <Tooltip title="刪除課程">
              <a onClick={(e) => onDelete(e, program.pid)}>
                <DeleteOutlined />
              </a>
            </Tooltip>
            <Tooltip title="下載報告">
              <a onClick={(e) => onDownload(e, program)}>
                <DownloadOutlined />
              </a>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "建立日期",
      dataIndex: "createDate",
      key: "createDate",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.createDateMS - b.createDateMS,
      sortDirections: ["descend"],
    },
  ];
  /*eslint-disable*/

  useEffect(() => {
    getProgramList();
  }, []);

  const getProgramList = async () => {
    setLoading(true);
    try {
      const res = await programList();
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setProgramData(
          res.map((program) => {
            return {
              key: program.id,
              name: program.title,
              referenceId: program.referenceId || "",
              activated: program.activated,
              url: `${replaceUrlByParams(PAGE.LANDING, {
                ":pid": program.id,
              })}`,
              more: { pid: program.id, title: program.title },
              createDate: moment(program.createDate).format(TIME_FORMAT),
              createDateMS: program.createDate, //hidden col for sorting
            };
          })
        );
      }
    } catch (e) {
      // console.log(e)
    } finally {
      setLoading(false);
    }
  };

  const onClone = async (e, { pid, title }) => {
    e.stopPropagation();

    const cloneProgramNameForm = (
      <Form className="clone-program-form" layout="vertical" form={form}>
        <Form.Item layout="vertical" label="課程名稱" name="title">
          <Input onFocus={(e) => e.target.select()} />
        </Form.Item>
      </Form>
    );

    form.setFieldsValue({ title: `複製 - ${title}` });
    confirm({
      title: "確定複製課程？",
      icon: <ExclamationCircleOutlined />,
      content: cloneProgramNameForm,
      okText: "確定",
      cancelText: "取消",

      async onOk() {
        try {
          const res = await programClone(pid, form.getFieldValue("title"));
          if (res.error) {
            throw new Error(`${res.error.msgCode} - ${res.error.message}`);
          } else {
            message.success("複製成功", 1, () => location.reload());
          }
        } catch (e) {
          // console.log(e)
        }
      },
    });
  };
  const onDelete = async (e, pid) => {
    e.stopPropagation();

    confirm({
      title: "確認刪除課程？",
      icon: <WarningOutlined />,
      okText: "確認",
      okType: "danger",
      cancelText: "取消",
      async onOk() {
        try {
          const res = await programDelete(pid);
          if (res && res.error) {
            throw new Error(`${res.error.msgCode} - ${res.error.message}`);
          } else {
            message.success("刪除成功，重新導向至課程列表", 1, () =>
              location.reload()
            );
          }
        } catch (e) {
          // console.log(e)
        }
      },
    });
  };
  const onDownload = async (e, program) => {
    e.stopPropagation();

    try {
      const res = await reportDownload(program.pid);

      if (res.type.includes("application/json")) {
        let reader = new FileReader();
        reader.onload = function (event) {
          console.log(reader);
          let content = reader.result;
          let errMessage = JSON.parse(content).message; // 错误信息

          throw new Error(`${errMessage}`);
          message.error("下載失敗，請重新再試");
        };
        // reader.readAsText(res)
      } else {
        fileDownload(
          res,
          `${program.title} Report ${moment().format("DDMMYYYY")}.xlsx`
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="program-list-page">
      <Title level={4}>課程列表</Title>
      <Search placeholder="搜尋課程名稱" onSearch={(e) => setSearch(e)} />
      <Table
        pagination={false}
        columns={columns}
        dataSource={programData.filter((e) =>
          `${e.name}${e.referenceId}`
            .toLowerCase()
            .includes(search.toLowerCase())
        )}
        onRow={(record) => {
          return {
            onClick: (event) => {
              history.push(
                `${replaceUrlByParams(PAGE.ADMIN_PROGRAM_DETAIL, {
                  ":pid": record.key,
                })}`
              );
            },
          };
        }}
      />
    </div>
  );
}

export default ProgramListPage;
